
import Vue from "vue";
import NavSideBar from "@/components/candidate/NavSideBar.vue";
import GuidedTooltip from "@/components/shared/GuidedTooltip.vue";
// import { process_tenant_registration } from "@/utils/principle_assessments"; // COMMENTED OUT
import { mapActions, mapGetters } from "vuex";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import { 
  TOOLTIP_VISIBLE,
  TOOLTIP_CURRENT_ID,
  TOOLTIP_CURRENT_STEP
} from "@/store/modules/tooltip/constants";

export default Vue.extend({
  name: "CandidateWrapper",
  components: { 
    NavSideBar,
    GuidedTooltip 
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    ...mapGetters("tooltip", {
      tooltipsVisible: TOOLTIP_VISIBLE,
      currentTooltipId: TOOLTIP_CURRENT_ID,
      currentStep: TOOLTIP_CURRENT_STEP,
      currentTooltipConfig: "currentTooltipConfig"
    })
  },
  methods: {
    ...mapActions("tooltip", {
      nextTooltipStep: "nextTooltipStep",
      previousTooltipStep: "previousTooltipStep",
      completeTooltip: "completeTooltip",
      skipTooltip: "skipTooltip"
    }),
    
    // Tooltip event handlers
    onStepChanged(step: number) {
      // Step change is handled by the component internally
    },
    
    onTooltipSkipped() {
      this.skipTooltip();
    },
    
    onTooltipFinished() {
      this.completeTooltip();
    },
    
    onTooltipClosed() {
      this.skipTooltip();
    }
  }
});
